import PropTypes from "prop-types";

/**
 * A button for performing various actions (submit, open, close, cancel, etc)
 * @name TranslationButton
 * @param className
 * @param id
 * @param label
 * @param onClick
 * @return {JSX.Element}
 * @constructor
 */
const TranslationButton = ({ className, id, label, onClick }) => {
    return (
        <button className={className} id={id} onClick={onClick} tabIndex={0} type="button">
            {label}
        </button>
    );
};

TranslationButton.propTypes = {
    className: PropTypes.string,
    id: PropTypes.string,
    label: PropTypes.string,
    onClick: PropTypes.func
};

TranslationButton.defaultProps = {
    className: "translation-button",
    id: "",
    label: "",
    onClick: null
};

export default TranslationButton;
